import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import axios from 'axios'
import VueAxios from 'vue-axios'
import IdleVue from "idle-vue";
import "slick-carousel/slick/slick.css";

Vue.config.productionTip = false
const eventsHub = new Vue();
const options = { eventEmitter: eventsHub, idleTime: 1800000 };

Vue.use(IdleVue, options);
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
